export var Runtime;
(function (Runtime) {
    let Client;
    (function (Client) {
        let Storage;
        (function (Storage) {
            /**
             * Defined in:
             *   {@link file://./../../dxos/config.proto}
             */
            let StorageDriver;
            (function (StorageDriver) {
                StorageDriver[StorageDriver["RAM"] = 0] = "RAM";
                StorageDriver[StorageDriver["IDB"] = 1] = "IDB";
                StorageDriver[StorageDriver["CHROME"] = 2] = "CHROME";
                StorageDriver[StorageDriver["FIREFOX"] = 3] = "FIREFOX";
                StorageDriver[StorageDriver["NODE"] = 4] = "NODE";
                StorageDriver[StorageDriver["WEBFS"] = 5] = "WEBFS";
                StorageDriver[StorageDriver["LEVELJS"] = 11] = "LEVELJS";
                StorageDriver[StorageDriver["JSONDOWN"] = 12] = "JSONDOWN";
            })(StorageDriver = Storage.StorageDriver || (Storage.StorageDriver = {}));
        })(Storage = Client.Storage || (Client.Storage = {}));
    })(Client = Runtime.Client || (Runtime.Client = {}));
})(Runtime || (Runtime = {}));
//# sourceMappingURL=config.js.map